<template>
  <PageVenueFilter :value="venueId" @input="$store.dispatch('pos/general/selectVenueId', $event)">
    <VenueFloorplans v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import VenueFloorplans from "./VenueFloorplans.vue";

export default {
  components: {
    PageVenueFilter,
    VenueFloorplans
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId"
    })
  }
};
</script>